var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTalk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 235,
    viewBox: "0 0 180 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.825 0H7.18098C3.19721 0 0 3.12494 0 6.96344V114.909C0 118.772 3.22258 121.872 7.18098 121.872H43.1364L38.9242 157.206C38.5943 160.061 40.0661 162.817 42.6796 164.17C43.7454 164.711 44.9125 164.982 46.0544 164.982C47.7291 164.982 49.3785 164.416 50.7233 163.309L100.914 121.848H172.799C176.783 121.848 179.98 118.723 179.98 114.884V6.96344C179.98 3.10033 176.758 0 172.799 0H172.825ZM165.644 107.946H98.3002C96.6001 107.946 94.9253 108.536 93.6313 109.619L55.3161 141.262L58.361 115.746C58.5893 113.777 57.955 111.784 56.5848 110.308C55.2146 108.831 53.2608 107.97 51.2055 107.97H14.3619V13.9515H165.618V107.946H165.644Z",
    fill: "url(#paint0_linear_193_2035)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.198 49.9949H137.782C141.778 49.9949 144.984 46.6296 144.984 42.4958C144.984 38.3619 141.752 34.9966 137.782 34.9966H42.198C38.2026 34.9966 34.9961 38.3619 34.9961 42.4958C34.9961 46.6296 38.228 49.9949 42.198 49.9949Z",
    fill: "url(#paint1_linear_193_2035)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.198 89.9905H137.782C141.778 89.9905 144.984 86.6252 144.984 82.4914C144.984 78.3575 141.752 74.9922 137.782 74.9922H42.198C38.2026 74.9922 34.9961 78.3575 34.9961 82.4914C34.9961 86.6252 38.228 89.9905 42.198 89.9905Z",
    fill: "url(#paint2_linear_193_2035)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1128 221.981V195.749H11.1689V189.135H38.9308V195.749H28.9869V221.981H21.1128ZM43.2968 221.981L54.0506 189.135H64.3994L75.1083 221.981H66.6942L59.27 195.659H59.18L51.7108 221.981H43.2968ZM50.316 215.187V208.753H68.089V215.187H50.316ZM85.2617 221.981V189.135H93.1358V215.367H109.424V221.981H85.2617ZM120.528 221.981V189.135H128.177V203.353H128.267L139.876 189.135H148.875L136.007 205.018L149.325 221.981H140.326L128.267 206.683H128.177V221.981H120.528Z",
    fill: "url(#paint3_linear_193_2035)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_193_2035",
    x1: 89.9901,
    y1: 0,
    x2: 89.9901,
    y2: 164.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2AFB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_193_2035",
    x1: 89.99,
    y1: 34.9966,
    x2: 89.99,
    y2: 49.9949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2AFB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_193_2035",
    x1: 89.99,
    y1: 74.9922,
    x2: 89.99,
    y2: 89.9905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2AFB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_193_2035",
    x1: 79.999,
    y1: 169.981,
    x2: 79.999,
    y2: 234.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2AFB3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalk);
export default __webpack_public_path__ + "static/media/talk.de54399c9227b70babf06c3a43b6e329.svg";
export { ForwardRef as ReactComponent };